import { RootState } from 'duck/store'

import { FlashNoticeVariant } from '../presentational'

export type FlashNoticeState = FlashContent[]

export type FlashContent = {
  show: boolean
  message: string
  variant: FlashNoticeVariant | null
  autoHide: boolean
}

export const FLASH_NOTICE_STORE_ID = 'FlashNotice'

export function getAccessibleState(state: RootState): FlashNoticeState {
  return state.components[FLASH_NOTICE_STORE_ID]
}
